module.exports = __webpack_public_path__ + "static/step3_mission_clock_bg-b92653c8cc9139abe0defcddce189491.svg";